import { useCustomerQuery } from '@graphcommerce/magento-customer'
import { PageMeta } from '@graphcommerce/magento-store'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { Paper } from '@mui/material'
import { SwitchCompanyAccount } from '../../../components/Account/SubUser/SwitchCompanyAccount'
import { ChangeNameForm } from '../../../components/Customer/ChangeNameForm/ChangeNameForm'
import { ChangePasswordForm } from '../../../components/Customer/ChangePasswordForm/ChangePasswordForm'
import { UpdateCustomerEmailForm } from '../../../components/Customer/UpdateCustomerEmailForm/UpdateCustomerEmailForm'
import { FormSkeleton } from '../../../components/Skeleton/FormSkeleton'
import { CustomerDocument } from '../../../graphql/Customer.gql'

function AccountNamePage() {
  const dashboard = useCustomerQuery(CustomerDocument, {
    fetchPolicy: 'cache-and-network',
  })
  const customer = dashboard.data?.customer

  return (
    <div className='w-full'>
      <PageMeta title={i18n._(/* i18n */ 'Name')} metaRobots={['noindex']} />
      <div className='w-full'>
        {!customer && (
          <Paper elevation={3} className='md:px-15 p-10 md:py-8'>
            <div className='pt-0'>
              <span className='Type-XXL-Regular w-full'>Account</span>
              <hr className='mb-7 mt-2 text-20-grey' />
              <FormSkeleton />
            </div>
          </Paper>
        )}
        {customer && (
          <div>
            {customer && (
              <ChangeNameForm
                prefix={customer.prefix ?? ''}
                firstname={customer.firstname ?? ''}
                lastname={customer.lastname ?? ''}
                companyName={customer.company_name ?? ''}
                companyIndustry={customer.company_industry ?? ''}
                allowRemoteShoppingAssistance={customer.allow_remote_shopping_assistance ?? false}
              />
            )}
            {customer && (
              <>
                <ChangePasswordForm />
                {customer.email && <UpdateCustomerEmailForm email={customer.email} />}
              </>
            )}
            <Paper elevation={3} className='md:px-15 p-10 md:py-8'>
              <div className='pt-0'>
                <span className='Type-XXL-Regular w-full'>Company Account</span>
                <hr className='mb-7 mt-2 text-20-grey' />
                <span>
                  <Trans id='Company Account allows you to create sub users and roles.' />
                </span>
                <SwitchCompanyAccount />
              </div>
            </Paper>
          </div>
        )}
      </div>
    </div>
  )
}

export default AccountNamePage
